import BaseModel from './BaseModel';
import moment from 'moment';

/** Class representing a shift. */
class Shift extends BaseModel {
    constructor(properties) {
        super(properties);

        this.start_at = moment(this.start_at);
        this.stop_at  = moment(this.stop_at);

        // Do not import User here: User → services creates a TDZ cycle with
        // Bucketlists (Tasks → redux → bucketlists → services → Bucketlists → models → Shift).
        if (this.admins?.length && !this.admin_ids?.length) {
            this.admin_ids = this.admins.map(user => user.id).filter(Boolean);
        }
    }
}

export default Shift;
